export default "__VITE_ASSET__BSt3h_Jm__"